import { render, staticRenderFns } from "./VisitorAssignment.vue?vue&type=template&id=11b1c5b8&scoped=true"
import script from "./VisitorAssignment.vue?vue&type=script&lang=js"
export * from "./VisitorAssignment.vue?vue&type=script&lang=js"
import style0 from "./VisitorAssignment.vue?vue&type=style&index=0&id=11b1c5b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b1c5b8",
  null
  
)

export default component.exports